import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import { useSubscriptionListener } from 'src/api/queries';
import { enterpriseSubscriptionOptions } from 'src/api/queries/enterpriseSubscription';
import { queryAccessTokenClaims } from 'src/api/queries/user';
import { decodeAccessToken } from './decodeAccessToken';
import { userHelpers } from './userHelpers';

export function useSyncAccessTokenSubscriptionStatus() {
  const auth = useAuth0();
  const accessTokenClaims = useQuery({
    ...queryAccessTokenClaims,
    enabled: !!auth.user, // Calling getAccessTokenSilently without a user will trigger a redirect to login
  });
  const storeSubscription = useSubscriptionListener();
  const cloudSubscription = useQuery({
    ...enterpriseSubscriptionOptions(),
    enabled: false, // only listen for changes, dont trigger a fetch on mount
  });
  const hasSubscriptionFromApi = !!storeSubscription.data;
  const hasSubscriptionInToken = userHelpers.hasSubscription(
    accessTokenClaims.data
  );

  const tokenShouldHaveSubscription =
    (storeSubscription.isSuccess && !!storeSubscription.data) ||
    (cloudSubscription.isSuccess && !!cloudSubscription.data);
  const tokenShouldNotHaveSubscription =
    storeSubscription.isSuccess &&
    !storeSubscription.data &&
    cloudSubscription.isSuccess &&
    !cloudSubscription.data;

  const isOutOfSync =
    (tokenShouldHaveSubscription && !hasSubscriptionInToken) ||
    (tokenShouldNotHaveSubscription && hasSubscriptionInToken);

  useQuery({
    queryKey: [
      'syncAccessTokenSubscriptionStatus',
      hasSubscriptionFromApi,
      hasSubscriptionInToken,
    ],
    enabled: !!auth.user && isOutOfSync,
    queryFn: async () => {
      await auth
        .getAccessTokenSilently({ cacheMode: 'off' })
        .then(decodeAccessToken);

      return null;
    },
    refetchInterval: 5000,
    staleTime: 0,
  });
}
